module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWBAMAAAA2mnEIAAAAIVBMVEUAAAAeHh4XFxcaGhoZGRkaGhoYGBgZGRkaGhoZGRkZGRnX8QQGAAAAC3RSTlMAESJEZneImaq7zKY3Gp4AAACDSURBVBgZBcEhEoJAAADAZeAGaRgovIInXDHYDgflGxgYK5V2waDRyivdBc4Auv34jED1xjWCFcxQD6BccAFMFFmHp6YVopDUSZWc8LBi0yC8ErIevvDTo74v+GlwNyM7EZKwsAlRh5sqKTKgabkAJtQDKBdYwQyqN64R6PbjMwI4gz8K4xcu3HxRcgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/popup-close.png
// module id = 671
// module chunks = 0